import React, { Component } from 'react';
import { SelectBox } from 'devextreme-react/select-box';
import DateBox from 'devextreme-react/date-box';
import DataGrid, {
    Column,
    Grouping,
    ColumnFixing,
    HeaderFilter, Pager,
    Paging,
    Editing,
    Lookup,
    RequiredRule,
    SearchPanel,
    SortByGroupSummaryInfo,
    Summary, TotalItem, Selection
} from 'devextreme-react/data-grid'; //npm i devextreme-react
import Modal from 'react-modal'; //npm install --save react-modal;
import { LoadPanel } from 'devextreme-react/load-panel';
import Swal from 'sweetalert2';
import { currencySymbolFormats, DateFormat, precisionFormats } from '../../helpers/fixcodes.js';
import { formatDate, getRequestParams, numberGridFormat } from '../../helpers/globalfunctions.js';
import RadioGroup from 'devextreme-react/radio-group';
import { Template } from 'devextreme-react';
import moment from "moment/min/moment-with-locales";
import { format } from "date-fns";
const addressTypeRadio = ['Post', 'Advance'];
const position = { of: '#historydiv' };
const customStyles = {
    content: {
        width: '50%',
    }
}

export class GenerateDraftInvoiceComponent extends Component {
    static displayName = GenerateDraftInvoiceComponent.name;
    constructor(props) {
        super(props);
        this.state = {
            termTypeList: [],
            loadPanelVisible: false,
            invoiceStartDate: new Date(),
            invoiceEndDate: new Date(),
            invoiceDate: new Date(new Date(new Date).setDate(1)),
            termTypeId: 0,
            serviceTypeId: 0,
            selectionRowKey: [],
            itemList :[],
            selectionRowKeyModel: [],
            generateInvoiceList: null,
            pastGenerateInvoiceList: null,
            generateInvoiceDetailList: [],
            sessionUser: JSON.parse(sessionStorage.getItem("sessionUser")),
            addressType: addressTypeRadio[0],
            vehicleAndDeviceModel: false,
            vehicleDeviceList: null,
            filterRowsId: [],
            gridValue: true,
            invoiceid :0,
            custId :0,
            contId :0,
            pastSelectionRowKey: [],
            proRata : "",
            customerList: null,
            filterCustomerId: 0,
                Qty :0,
                UnitPrice :0,
                GrossAmount :0,
                TotalTax :0,
                TotalAmount :0,

        }
    }
    
    async componentDidMount() {
        this.state.itemList.push({id:"Y", name:"Yes"}) 
        this.state.itemList.push({id:"N", name:"No"}) 
         await this.getAutoGenerateInvoice();

    }
    getPaymentTermType = async () => {
        try {
            var request = {};
            const requestParams = getRequestParams("GET", request);
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'paymentTermType/dropdownType', requestParams);
            const data = await response.json();

            this.setState({
                termTypeList: data.payload
            });
        } catch (err) {
            console.log("Error in " + this.displayName + ".getPaymentTermType function", err);
        }
    }


    handlerowPrepared = (e) => {
        if (e.rowType === "data")  {     
            if (e.data.cnt > 0) {
                e.rowElement.style.backgroundColor = '#cdffcd';
                e.rowElement.style.color = '#FF0000';
            }
        }
    }
    handlevehrowPrepared = (e) => {
        if (e.rowType === "data")  {
            if (e.data.cnt > 0) {   
                e.rowElement.style.backgroundColor = '#cdffcd'; 
                e.rowElement.style.color = '#FF0000';
            }
        }
    }
    getCustomer = async () => {
        this.setState({
            loadPanelVisible: true
        });
        try {
            const requestParams = getRequestParams("GET", null);
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'account/dropdownAccount/2', requestParams);
            const data = await response.json();

            this.setState({
                customerList: data.payload,
                loadPanelVisible: false
            });
        } catch (err) {
            console.log("Error in " + this.displayName + ".getQc function", err);
            this.setState({
                loadPanelVisible: false
            });
        }
    }
   

    CalculateInvoice  = async (e) => {    
        e.preventDefault();
        console.log(e.value)
        try {
            let invoiceDetailList = [];
            this.state.vehicleDeviceList.map((gridData, i) => {
                let newgrid = new Object();
                newgrid.id = gridData.id;
                newgrid.noOfDays = gridData.noOfDays;
                newgrid.unitPrice = gridData.unitPrice;
                newgrid.mondys = gridData.monDys;
                newgrid.isBillable = gridData.isBillable;  
                newgrid.IsPrintable = gridData.isPrintable;
                newgrid.proRata = this.state.proRata;
                newgrid.custId = this.state.custId;
                newgrid.contId = this.state.contId;

                invoiceDetailList.push(newgrid);  

            })
            console.log("invoiceDetailList===>", invoiceDetailList)
            var request = new Object();
             request.updateInvoiceDetails = invoiceDetailList;
                       const requestParams = getRequestParams('POST',  request);
                        const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'invoice/getDrafcalculate', requestParams)
                        const data  = await response.json();
                         this.setState({
                            Qty: data.qty,
                            UnitPrice : data.unitPrice,
                            GrossAmount : data.grossAmount, 
                            TotalTax : data.taxAmount,
                            TotalAmount : data.totalAmount}
                            );

                            
                                                        // .then(response => console.log(response.json()) )
                        // .then(data =>   console.log("data===>", data.payload) )
            //                 .then(data => { console.log("data===>", request.invoiceDetailList) })
            //                  const data = await response.json();    
            console.log("data===>",    JSON.stringify( data, null, 2))
           
     
        }
        catch (err) {   
             console.log("Error in RANJIT " + this.displayName + ".handleGenerateInvoice function", err.message);

        }     
    }
    
    onEditorPreparing = async (e) => {
        if (e.dataField === 'proRata') {
       
            const currentValue = e.value; // This is the current value in the cell
    
            // console.log('Current department ID before edit:', e.row);
        
            // // Optional: Add live value change handler
            // // e.editorOptions.onValueChanged = (args) => {
    
            //    try  {
            //         const newValue = args.value; // This is the new value selected in the dropdown
            //         console.log('New department ID selected:', newValue);
            //     }
            //     catch (error) {     
            //         console.log("Error in " + this.displayName + ".onEditorPreparing function", error);
            //     }
                
    
                var onValueChanged = e.editorOptions.onValueChanged;  
                e.editorOptions.onValueChanged = function(args) {  
    
    
                     if (args.value != currentValue) {
                    var htmlMessage = "Do you want to Update" 
                    Swal.fire({
                        html: htmlMessage,//"Do you want to generate"+' '+list.length + ' ' +"draft invoice(s)",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes',
                        allowOutsideClick: false
                    }).then((result) => {
                        if (result.isConfirmed)  {
                    onValueChanged.apply(this, arguments);  
                            var request = new Object();
                            request.custid = e.row.data.customerId; 
                            request.contid = e.row.data.customerContractId;
                            request.flg = arguments[0].value   ;
                              const requestParams = getRequestParams("POST", request);
                             fetch(process.env.REACT_APP_API_BASE_URL + 'invoice/recalculateInvoice/ ' + e.row.data.customerId +
                               "/" + e.row.data.customerContractId + "/" + arguments[0].value  + ""  , requestParams); 
                                  console.log('New value selected:',  arguments[0].value   );
                       
                        }
                     
                    })
    
                // }
              
            
                   // your custom code here  
                }  
    
          };
          
         }
       };
    //  getDaysInMonth = (month, year) => {
    //     return new Date(year, month, 0).getDate();
    //   };
    
deleteInvoice = async (e) => {  

    let list = this.state.generateInvoiceList.filter((item) => this.state.selectionRowKey.filter((rowIndex) => rowIndex == item.rowIndex).length > 0);
    let filterRows = [];
 
    list.map((gridData, i) => {
  
        var request = new Object();
        request.custid = gridData.customerId; 
        request.contid = gridData.customerContractId;
          const requestParams = getRequestParams("POST", request);
         fetch(process.env.REACT_APP_API_BASE_URL + 'invoice/DeleteInvoice/ ' + gridData.customerId +
           "/" + gridData.customerContractId+ ""  , requestParams); 
              


        
    });


}
    handleGenerateInvoice = async (e) => {
        e.preventDefault();
        try {
            console.log(this.state.gridValue);
            if (this.state.gridValue === true) {
                if (this.state.selectionRowKey != null && this.state.selectionRowKey.length === 0) {
                    Swal.fire({
                        icon: 'error',
                        text: "Please select at least one row.",
                    }).then((result) => {
                        return;
                    });
                    return;
                }


                let invoiceDetailList = [];
                let customerList = [];
                let list = this.state.generateInvoiceList.filter((item) => this.state.selectionRowKey.filter((rowIndex) => rowIndex == item.rowIndex).length > 0);
                let filterRows = [];
                let customerName = [];
                //let filterRowsId = [];
                var i;
               

                list.map((gridData, i) => {
                    let newgrid = new Object();
                    newgrid.id = gridData.rowIndex;
                    newgrid.CustomerId = gridData.customerId;
                    newgrid.CustomerContractId = gridData.customerContractId;
                    newgrid.TotalTax = gridData.totalTaxAmount;
                    newgrid.activeQty = gridData.activeQty;
                    newgrid.unitPrice = gridData.unitPrice;
                    newgrid.TotalAmount = gridData.totalAmount;
                    newgrid.GrossAmount = gridData.grossAmount;
                    newgrid.TotalQty = gridData.totalItemQty;
                    newgrid.PaymentTermsId = gridData.paymentTermId;
                    newgrid.Remarks = gridData.Remarks;
                    newgrid.ServiceItemId = gridData.serviceItemId;
                    newgrid.PaymentTermId = gridData.paymentTermId;
                    newgrid.SoNo = gridData.soNo;
                    newgrid.proRata = gridData.proRata;
                    newgrid.BillingStartDate = gridData.billingMonthStart;
                    newgrid.BillingEndDate = gridData.billingMonthEnd;
                    newgrid.InvoiceDate = formatDate(gridData.invoiceDate, "yyyy-MM-dd");  
                    newgrid.taxValue = this.state.taxValue;
                    newgrid.referenceSONo = this.state.referenceSONo;
                    newgrid.BillingType = gridData.billingType;
                    newgrid.ServiceType = gridData.serviceType;
                    // newgrid.BillingType = this.state.termTypeId ;
                    // newgrid.ServiceType = this.state.serviceTypeId;
                    invoiceDetailList.push(newgrid);
                });
                console.log("invoiceDetailList==>",invoiceDetailList)

                // var htmlMessage = customerName.length == 0 ? "Do you want to generate" + ' ' + _list.length + ' ' + "draft invoice(s)" : message + "<br/>" + customerName.join("<br/>") + "<br/>" + "Do you want to still generate invoice"
                var htmlMessage = "Do you want to generate" + ' ' + list.length + ' ' + "draft invoice(s)"
                Swal.fire({
                    html: htmlMessage,//"Do you want to generate"+' '+list.length + ' ' +"draft invoice(s)",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes',
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.setState({ loadPanelVisible: true });
                        var request = new Object();
                        request.UserId = this.state.sessionUser.id;
                        request.autoGenerateInvoice = invoiceDetailList;
                        request.autoGenerateInvoicedetails = invoiceDetailList;
                        // request.BillingType = this.state.termTypeId == "Post" ? "Post" : "Advance";
                        request.BillingType =  "Post" ;
                        request.BillingFromDate = moment(this.state.invoiceStartDate).format(DateFormat.SqlStartDateFormat);
                        //request.BillingToDate = formatDate(this.state.invoiceEndDate, "yyyy-MM-dd");
                        request.BillingToDate = moment(this.state.invoiceEndDate).format(DateFormat.SqlEndDateFormat);
                        request.InvoiceDate = formatDate(this.state.invoiceDate, "yyyy-MM-dd");    
                        // request.ServiceType = this.state.serviceTypeId;
                        request.ServiceType = "Device";
                        request.BillDate = formatDate(this.state.invoiceDate, "yyyy-MM-dd");    
                        // console.log(JSON.stringify( request, null ))
                        const requestParams = getRequestParams('POST', request);
                        console.log("ranjit" +  JSON.stringify( request,null,0))
                        // fetch(process.env.REACT_APP_API_BASE_URL + 'invoice/autoGenerateInvoice', requestParams)
                        fetch(process.env.REACT_APP_API_BASE_URL + 'invoice/autoGenerateInvoice', requestParams)
                            .then(response => { if (response.ok) return response.json() })
                            .then(data => {
                                this.setState({ loadPanelVisible: false });
                                this.setState({invoiceid : data.payload})
                                if (data.isSuccess === true) {
                                    Swal.fire({
                                        icon: data.isSuccess === true ? 'success' : 'error',
                                        text: data.message,
                                        // text: data.message,
                                    }).then((result) => {
                                        if (data.isSuccess === true) {
                                            if (result.isConfirmed) {
                                                this.getAutoGenerateInvoice();
                                                this.setState({ loadPanelVisible: false });
                                            }
                                        }
                                    })
                                }
                            });
                    }
                })
            }
            else {
                if (this.state.pastSelectionRowKey != null && this.state.pastSelectionRowKey.length === 0) {
                    Swal.fire({
                        icon: 'error',
                        text: "Please select at least one row from pending invoice.",
                    }).then((result) => {
                        return;
                    });
                    return;
                }


                let invoiceDetailList = [];
                let customerList = [];
                let list = this.state.pastGenerateInvoiceList.filter((item) => this.state.pastSelectionRowKey.filter((rowIndex) => rowIndex == item.rowIndex).length > 0);
                let filterRows = [];
                let customerName = [];
                //let filterRowsId = [];
                var i;
              
                list.map((gridData, i) => {
                    let newgrid = new Object();
                    newgrid.id = gridData.rowIndex;
                    newgrid.CustomerId = gridData.customerId;
                    newgrid.CustomerContractId = gridData.customerContractId;
                    newgrid.TotalTax = gridData.totalTaxAmount;
                    newgrid.UnitPrice = gridData.unitPrice;
                    newgrid.TotalAmount = gridData.totalAmount;
                    newgrid.GrossAmount = gridData.grossAmount;
                    newgrid.TotalQty = gridData.totalItemQty;
                    newgrid.PaymentTermsId = gridData.paymentTermId;
                    newgrid.Remarks = gridData.Remarks;
                    newgrid.ServiceItemId = gridData.serviceItemId;
                    newgrid.PaymentTermId = gridData.paymentTermId;
                    newgrid.SoNo = gridData.soNo;
                    newgrid.BillingType = this.state.termTypeId == "Post" ? "Post" : "Advance";
                    invoiceDetailList.push(newgrid);
                });
                // var htmlMessage = customerName.length == 0 ? "Do you want to generate" + ' ' + _list.length + ' ' + "draft invoice(s)" : message + "<br/>" + customerName.join("<br/>") + "<br/>" + "Do you want to still generate invoice"
                var htmlMessage = "Do you want to generate" + ' ' + list.length + ' ' + "draft invoice(s)"
                Swal.fire({
                    html: htmlMessage,//"Do you want to generate"+' '+list.length + ' ' +"draft invoice(s)",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes',
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.setState({ loadPanelVisible: true });
                        var request = new Object();
                        request.UserId = this.state.sessionUser.id;
                        request.autoGenerateInvoice = invoiceDetailList;
                        request.autoGenerateInvoicedetails = invoiceDetailList;
                        const requestParams = getRequestParams('POST', request);
                        fetch(process.env.REACT_APP_API_BASE_URL + 'invoice/autoGenerateInvoice', requestParams)
                            .then(response => { if (response.ok) return response.json() })
                            .then(data => {
                                this.setState({ loadPanelVisible: false });
                                if (data.isSuccess === true) {
                                    Swal.fire({
                                        icon: data.isSuccess === true ? 'success' : 'error',
                                        text: data.message,
                                        // text: data.message,
                                    }).then((result) => {
                                        if (data.isSuccess === true) {
                                            if (result.isConfirmed) {
                                                this.setState({ pastSelectionRowKey: [] });
                                                this.getPastAutoGenerateInvoice();
                                            }
                                        }
                                    })
                                }
                            });
                    }
                })
            }



        } catch (err) {
            console.log("Error in " + this.displayName + ".handleGenerateInvoice function", err);
        }
    }
    handleMultipleSelectionChanged = (e) => {
        console.log(e.selectedRowKeys, e.selectedRowsData)
        this.setState({
            selectionRowKey: e.selectedRowKeys

        });
    }
    
    handleMultipleSelectionChangedModel = (e) => {
        console.log(e.selectedRowKeys)
        const { selectedRowKeys, selectedRowsData } = e;

        if (selectedRowKeys.length !== this.state.selectionRowKeyModel.length) {
            console.log("e.selectedRowKeys===>", selectedRowKeys);
            console.log("e.selectedRowsData===>", selectedRowsData);

            this.setState({
                selectionRowKeyModel: selectedRowKeys,
                selectedRowsData,
            });
        }
    };

getAutoGenerateInvoice = async () => {
        try {
            this.setState({ loadPanelVisible: true });
            var request = {};
          
            const requestParams = getRequestParams("GET", request);
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'invoice/getDraftInvoice', requestParams);
            const data = await response.json();
            console.log("data.payload===>",  data.payload)
            this.setState({
                generateInvoiceList: data.payload.customerCont,
                loadPanelVisible: false,
            })

            // const dateObject = new Date(Date.parse(this.state.generateInvoiceList.billingMonthStart));
            // console.log("data.payload===>", dateObject) 

        } catch (err) {
            // console.log("Error in " + this.displayName + ".getPaymentTermType function", err);
            this.setState({ loadPanelVisible: false });
        }
    }
    handlePastMultipleSelectionChanged = (e) => {
        console.log("AAA")
        console.log(e.selectedRowKeys)
        console.log(e.selectedRowKeys)
        this.setState({
            pastSelectionRowKey: e.selectedRowKeys,

        });
    }
    handleClear = () => {
        console.log("AAA")
        this.setState({
            termTypeId: 0,
            selectionRowKey: [],
            selectionRowKeyModel: [],
            pastSelectionRowKey: [],
        });
        setTimeout(() => this.getPastAutoGenerateInvoice(), 100);
        setTimeout(() => this.getAutoGenerateInvoice(), 100);
    }
    changeSelectionAddressType = (e) => {
        this.setState({
            addressType: e.value,
        });
        setTimeout(() => { this.getAutoGenerateInvoice() }, 500);
    }


    pastPendingGrid = (e) => {
        this.setState({
            addressType: "Post",
            gridValue: false,
        });
        setTimeout(() => { this.getPastAutoGenerateInvoice() }, 500);
    }

    showVehicleAndDevices = (e, data) => {
        e.preventDefault();
        this.setState({
            vehicleAndDeviceModel: data,
            Qty:0,
            UnitPrice:0,
            GrossAmount:0,
            TotalTax:0,
            TotalAmount:0,
            proRata : data.proRata,
            custId : data.customerId,
            contId : data.customerContractId

        })
        console.log("test===>", data.proRata    )
        setTimeout(() => {
            this.getContractItemList(data.customerId, data.soNo);
        }, 200);
    }
    getContractItemList = async (customerId, soNo) => {
        try {
            var request = {};
            request.customerId = customerId;
            request.SONo = soNo

            const requestParams = getRequestParams("POST", request);
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'contractItem/getContractItemDetails', requestParams);
            const data = await response.json();
             console.log("data.payload===>", data.payload)
            this.setState({
                vehicleDeviceList: data.payload,
            })

            console.log("vehicleDeviceList===>", this.state.vehicleDeviceList)

        } catch (err) {
            console.log("Error in " + this.displayName + ".getPaymentTermType function", err);
        }
    }

    closeModel = () => {
        this.setState({
            vehicleAndDeviceModel: false,
        })
    }
    UpdateData = async (e) => {
        e.preventDefault();
       let UpdateInvoiceDetails = {};
  
       try  {
       this.state.vehicleDeviceList.map((gridData, i) => {
        UpdateInvoiceDetails.id = gridData.id;
        UpdateInvoiceDetails.noOfDays = gridData.noOfDays;            
        UpdateInvoiceDetails.isBillable = gridData.isBillable;
        UpdateInvoiceDetails.isPrintable = gridData.isPrintable;
        UpdateInvoiceDetails.porRata =  this.state.proRata;
        
        console.log("request===>", JSON.stringify(UpdateInvoiceDetails,null, 2))
        const requestParams = getRequestParams('POST', UpdateInvoiceDetails);
        fetch(process.env.REACT_APP_API_BASE_URL + 'invoice/UpdateDraftInvoice'  , requestParams)
            .then(response => { if (response.ok) return response.json() })
            
        });
        }   
            catch (err) {
                console.log("Error in " + this.displayName + ".handleGenerateInvoice function", err);   
            }
         this.setState({
            vehicleAndDeviceModel: false,
        })


    }

    handleFilterCustomerChange = (selectedOption) => {
        this.setState({
            filterCustomerId: (selectedOption.selectedItem !== null ? selectedOption.selectedItem.id : 0)
        });
    }

    render() {
        const renderGridNumberCell = (data) => {
            return numberGridFormat(data.value)
        }
        const renderTotalGridNumberCell = (data) => {
            return numberGridFormat(data.value)
        }
        const customizeText = (data) => {
            var value = 'Total: ' + numberGridFormat(data.value);
            return value
        }
        const customizeGrossText = (data) => {
            var value = 'Total: ' + numberGridFormat(data.value);
            return value
        }
        const renderGridAmountCell = (data) => {
            return <div>{parseFloat(data.value).toFixed(precisionFormats[2])}</div>;
        }
        const renderGridCell = (data) => {
            // console.log("data.value===>", data.data)
            return <div>
                <a href="/#" title="Address" onClick={(e) => { this.showVehicleAndDevices(e, data.data) }} >{data.value}</a>
            </div>;
        }
        const renderGridCellButton = (data) => {
            return <div className='d-flex'>
                {/* <RadioGroup items={addressTypeRadio} defaultValue={addressTypeRadio[0]} layout="horizontal" value={this.state.addressType} onValueChanged={this.changeSelectionAddressType} /> */}
                {/* <button type="submit" className="btn b  tn-success"  onClick={this.handleGenerateInvoice}> 
                    Generate Invoice
                </button> */}
                <div>
                <button type="submit" className="btn btn-success"  onClick={this.handleGenerateInvoice}> 
                    Approve 
                 </button>
                 <button type="submit" className="btn btn-success" onClick={this.deleteInvoice} > 
                    Delete 
                 </button>
                 </div> 
                     <div className='ml-1'>
                                        <button  type="submit" className="btn btn-success" onClick={this.getAutoGenerateInvoice}>
                                            Refresh     
                                        </button>
                                </div>
            </div>;
        }


        return (
            <div className="section-body">
                
              
                <div className='card'>
                    
                    <div className='card-body'>
                          {/* <RadioGroup items={addressTypeRadio} defaultValue={addressTypeRadio[0]} layout="horizontal" value={this.state.addressType} onValueChanged={this.changeSelectionAddressType} /> */}
   
                        <div className="mt-3">
                            {/* <ul className="nav nav-tabs mt-1 ml-2" id="custom-tabs-tab" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" id="custom-tabs-home-tab" data-toggle="pill" href="#custom-tabs-home" role="tab" aria-controls="custom-tabs-home" aria-selected="true" onClick={(e) => this.setState({ gridValue: true })} >Active Customer Contract</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" id="custom-tabs-profile-tab" data-toggle="pill" href="#custom-tabs-profile" role="tab" aria-controls="custom-tabs-profile" aria-selected="false" onClick={(e) => this.pastPendingGrid()}   >Pending Customer Contract</a>
                                </li>
                            </ul> */}
         
                            <div className="tab-content tab-bordered" id="custom-tabs-tabContent" >
                                <div className="tab-pane fade active show" id="custom-tabs-home" role="tabpanel" aria-labelledby="custom-tabs-home-tab"  >
                                    <DataGrid
                                        dataSource={this.state.generateInvoiceList}
                                        keyExpr="rowIndex"
                                        id='gridGenerateInvoiceList'
                                        columnsAutoWidth={false}
                                        showColumnLines={true}
                                        showRowLines={true}
                                        showBorders={true}
                                        rowAlternationEnabled={false}
                                        onEditorPreparing={this.onEditorPreparing}
                                        onClick={(e) => {
                                            console.log(e.dataField)
                                            // Disable editing for a specific row or field
                                            if (e.dataField != 'proRata' ) {
                                              e.cancel = true;
                                              
                                            }}}
                                            onCellValueChanged={(e) => {
                                                // if (e.dataField === 'proRata') {
                                                  console.log('Lookup value changed:', e.value);
                                                // }
                                              }}
                                        allowColumnResizing={true}
                                        onRowPrepared={this.handlerowPrepared}
                                        columnResizingMode='widget'
                                        onSelectionChanged={this.handleMultipleSelectionChanged}
                                        onToolbarPreparing={(e) => {
                                            // if (this.state.selectionRowKey.length > 0) {
                                                e.toolbarOptions.items.unshift({
                                                    location: 'before',
                                                    template: 'generateButton',
                                                });
                                            // }
                                    
                                        }}>
                                        <Template name="generateButton" render={renderGridCellButton} />
                                        {/* <Template name="generateButton" render={renderDraftButton} /> */}
                                        <Selection
                                            mode="multiple"
                                            selectAllMode={"allPages"}
                                            showCheckBoxesMode={"always"}

                                        />
                                            <Editing mode="cell"
                                        allowUpdating={true}
                                        allowDeleting={false}
                                        allowAdding={false}
                                        editorOptions={true} />
                                           {/* <Editing mode="row" allowUpdating={true} allowDeleting={true} allowAdding={true} /> */}
                                        <Column dataField="customerName" caption="Customer" allowEditing={false} allowSearch={true} allowFiltering={false} allowSorting={true} width={300} />
                                        <Column dataField="referenceName" caption="Reference Name" allowSearch={true} allowEditing={false} allowFiltering={false} allowSorting={true} width={100} />
                                        <Column dataField="referenceSONo" caption="Refernce PO" allowSearch={true} allowFiltering={false} allowSorting={true} width={100} />
                                        <Column dataField="soNo" caption="SO#" allowSearch={true} allowEditing={false} allowFiltering={false} allowSorting={true} width={100} />
                                        <Column dataField="proRata"  caption="PRo-Rata"  allowSearch={true}  allowSorting={true} width={100} >
                                                    <Lookup dataSource={this.state.itemList} displayExpr="name" valueExpr="id" />
                                                     <RequiredRule></RequiredRule> 
                                         </Column>
                                        <Column dataField="paymentTermName" caption="Payment Term" allowSearch={true} allowEditing={false} allowFiltering={false} allowSorting={true} width={80} />
                                        {/* <Column dataField="contractItemQty" caption=" Contract Item Qty" allowSearch={true} allowFiltering={false} allowSorting={true} width={100} cellRender={renderGridCell} /> */}
                                        <Column dataField="activeQty" caption="Active Qty" allowSearch={true} allowEditing={false} allowFiltering={false} allowSorting={true} width={80} cellRender={renderGridCell} />
                                        <Column dataField="unitPrice" caption="Unit Rate" allowSearch={true}   allowEditing={false} allowFiltering={false} allowSorting={true} width={80}  />
                                        <Column dataField="grossAmount" caption="Basic Amount" allowSearch={true} allowEditing={false}  allowFiltering={false} allowSorting={true} width={120} />
                                        <Column dataField="totalTaxAmount" caption="Total Tax" allowSearch={true} allowEditing={false}  allowFiltering={false} allowSorting={true} width={120} cellRender={renderTotalGridNumberCell} />
                                        <Column dataField="totalAmount" caption="Total Amount" allowSearch={true}  allowEditing={false} allowFiltering={false} allowSorting={true} minWidth={100}
                                            format={"#,##0.###"}
                                            cellRender={renderGridNumberCell}
                                        />
                                                        <Column dataField="billingType" caption="Billing" allowEditing={false}  allowSearch={true} allowFiltering={false} allowSorting={true} width={80} />
                                                                                <Column dataField="serviceType"  allowEditing={false} caption="Service" allowSearch={true} allowFiltering={false} allowSorting={true} width={80} />
                                                                                <Column dataField="billingMonthStart"  allowEditing={false}  caption="Billing MonthStart" allowSearch={true} allowFiltering={false} allowSorting={true} width={80} dataType="date" format="dd-MMM-yyyy" />                                                                                
                                                                                <Column dataField="billingMonthEnd"   allowEditing={false} caption="Billing Monthend" allowSearch={true} allowFiltering={false} allowSorting={true} width={80}  dataType="date" format="dd-MMM-yyyy" />                                                                                
                                                                                <Column dataField="invoiceDate" allowEditing={false} caption="Billing Date" allowSearch={true} allowFiltering={false} allowSorting={true} width={80}  dataType="date" format="dd-MMM-yyyy"/>                                                                                
                                          <Column dataField="customerContractId" caption="Contractid" allowSearch={true} allowEditing={false}  allowFiltering={false} allowSorting={true} width={120}  />
                                        <Column dataField="customerId" caption="Customer id" allowSearch={true} allowEditing={false}  allowFiltering={false} allowSorting={true} width={120}  />

                                        {/* <Column dataField="amountDue" caption="Amount Due" allowSearch={true} allowFiltering={false} allowSorting={true} width={150} cellRender={renderGridAmountCell} />
                                <Column dataField="dueDate" caption="Due Date" allowSearch={true} allowFiltering={false} allowSorting={true} width={150} format={DateFormat.DateNorthFormat} dataType="datetime" /> */}
                                        <Summary>
                                            <TotalItem column="grossAmount" summaryType="sum" customizeText={customizeGrossText} />
                                            <TotalItem column="totalTax" summaryType="sum" customizeText={customizeText} />
                                        </Summary>
                                        <SortByGroupSummaryInfo summaryItem="count" />
                                        <HeaderFilter visible={true} />
                                        <SearchPanel visible={true} highlightCaseSensitive={true} width={240} placeholder="Search..." />
                                        <Grouping autoExpandAll={true} />
                                        <Paging defaultPageSize={10} />
                                        <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 50, 500]} showInfo={true} visible={true} />
                                        <ColumnFixing enabled={true} />
                                    </DataGrid>
                                </div>
                                <div className="tab-pane fade" id="custom-tabs-profile" role="tabpanel" aria-labelledby="custom-tabs-profile-tab" >
                                    <DataGrid
                                        dataSource={this.state.pastGenerateInvoiceList}
                                        keyExpr="rowIndex"
                                        //  id='gridGenerateInvoiceList'
                                        columnsAutoWidth={false}
                                        showColumnLines={true}
                                        showRowLines={true}
                                        showBorders={true}
                                        rowAlternationEnabled={false}
                                        allowColumnResizing={true}
                                        onEditorPreparing={this.onEditorPreparing}
 
                                        columnResizingMode='widget'
                                        onEditingStart={(e) => {
                                            if (e.dataField != 'proRata' ) {
                                              e.cancel = true;
                                            }}}
                                            onCellValueChanged={(e) => {
                                                // if (e.dataField === 'proRata') {
                                                  console.log('Lookup value changed:', e.value);
                                                // }
                                              }}
                                        //selectedRowKeys={this.state.selectionRowKey}
                                        onSelectionChanged={this.handlePastMultipleSelectionChanged}
                                        onToolbarPreparing={this.onToolbarPreparing}>
                                        <Selection
                                            mode="multiple"
                                            selectAllMode={"allPages"}
                                            showCheckBoxesMode={"always"}
                                        />
                                       <Editing mode="cell"
                                        allowUpdating={true}
                                        allowDeleting={false}
                                        allowAdding={false}
                                        editorOptions={true} />

                                        <Column dataField="customerName" caption="Customer" allowSearch={true} allowFiltering={false} allowSorting={true} width={450} />
                                        <Column dataField="soNo" caption="SO#" allowSearch={true} allowFiltering={false} allowSorting={true} width={100} />
                               <Column dataField="proRata"  caption="Item" >
                                                    <Lookup dataSource={this.state.itemList} displayExpr="name" valueExpr="id" />
                                                    <RequiredRule></RequiredRule>
                                                    </Column>
                                        <Column dataField="paymentTermName" caption="Payment Term" allowSearch={true} allowEditing={false}  allowFiltering={false} allowSorting={true} width={120} />
                                        {/* <Column dataField="contractItemQty" caption="Item Qty" allowSearch={true} allowFiltering={false} allowSorting={true} width={80} cellRender={renderGridCell} /> */}
                                        <Column dataField="activeQty" caption="Active Qty" allowSearch={true}  allowEditing={false} allowFiltering={false} allowSorting={true} width={80} cellRender={renderGridCell} />
                                        <Column dataField="referenceSONo" caption="Refernce PO" allowSearch={true}  allowEditing={false} allowFiltering={false} allowSorting={true} width={100} />

                                        <Column dataField="unitPrice" caption="Unit Rate" allowSearch={true} allowEditing={false} allowFiltering={false} allowSorting={true} width={80} />
                                        <Column dataField="grossAmount" caption="Basic Amount" allowSearch={true} allowEditing={false} allowFiltering={false} allowSorting={true} width={80} />

                                        <Column dataField="totalTaxAmount" caption="Total Tax" allowSearch={true} allowEditing={false} allowFiltering={false} allowSorting={true} width={200} cellRender={renderTotalGridNumberCell} />
                                        <Column dataField="totalAmount" caption="Total Amount" allowSearch={true} allowEditing={false} allowFiltering={false} allowSorting={true} minWidth={100}
                                            format={"#,##0.###"}
                                            cellRender={renderGridNumberCell}
                                        />
                                        <Column dataField="billingType" caption="Billing" allowEditing={false} allowSearch={true} allowFiltering={false} allowSorting={true} width={80} />
                                         <Column dataField="serviceType" allowEditing={false} caption="Service" allowSearch={true} allowFiltering={false} allowSorting={true} width={80} />
                                         <Column dataField="billingMonthStart"  allowEditing={false}  caption="BillingMonthStart" allowSearch={true} allowFiltering={false} allowSorting={true} width={80} dataType="date" format="dd-MMM-yyyy" />                                                                                
                                         <Column dataField="billingMonthEnd"    allowEditing={false} caption="Billing Monthend" allowSearch={true} allowFiltering={false} allowSorting={true} width={80}  dataType="date" format="dd-MMM-yyyy" />                                                                                
                                          <Column dataField="invoiceDate" allowEditing={false} caption="Billing Date" allowSearch={true} allowFiltering={false} allowSorting={true} width={80}  dataType="date" format="dd-MMM-yyyy"/>                                                                                
                                          <Column dataField="customerContractId" caption="Contractid" allowSearch={true} allowEditing={false}  allowFiltering={false} allowSorting={true} width={120}  />
                                        <Column dataField="customerId" caption="Customer id" allowSearch={true} allowEditing={false}  allowFiltering={false} allowSorting={true} width={120}  />

                                        {/* <Column dataField="amountDue" caption="Amount Due" allowSearch={true} allowFiltering={false} allowSorting={true} width={150} cellRender={renderGridAmountCell} />
                                <Column dataField="dueDate" caption="Due Date" allowSearch={true} allowFiltering={false} allowSorting={true} width={150} format={DateFormat.DateNorthFormat} dataType="datetime" /> */}
                                        <Summary>
                                            <TotalItem column="grossAmount" summaryType="sum" customizeText={customizeGrossText} />
                                            <TotalItem column="totalTax" summaryType="sum" customizeText={customizeText} />
                                        </Summary>
                                        <SortByGroupSummaryInfo summaryItem="count" />
                                        <HeaderFilter visible={true} />
                                        <SearchPanel visible={true} highlightCaseSensitive={true} width={240} placeholder="Search..." />
                                        <Grouping autoExpandAll={true} />
                                        <Paging defaultPageSize={10} />
                                        <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 50, 500]} showInfo={true} visible={true} />
                                        <ColumnFixing enabled={true} />
                                    </DataGrid>
                                </div>
                            </div>
                        </div>

                    </div>

                    <Modal ariaHideApp={false}
                        isOpen={this.state.vehicleAndDeviceModel}
                        style={customStyles}
                        className={"react-modal "}
                        onRequestClose={this.closeModel}
                        shouldCloseOnOverlayClick={false}
                        contentLabel="Example Modal">
                        <form method="post" style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                            <div className="modal-header" style={{ display: "flex", textAlign: "center", justifyContent: "center", backgroundColor: "#035090", color: "white" }}>
                                {/* <h6 className="modal-title">Quantity</h6> */}
                                            <h6 style={{ fontSize: "12px", color: "White" }}>Customer  Name : - </h6>
                                            <h6>{this.state.vehicleAndDeviceModel.customerName}</h6>
                            

                            </div>
                            {/* <div style={{ justifyContent: "center", alignItems: "center", padding: 20, backgroundColor: 'white' }}> */}
                                {/* <h6 style={{ color: '#035090 ' }}>Invoice Information</h6> */}
                                <div style={{ display: "flex",  padding: 5, paddingBottom: 0, backgroundColor: 'white' }}>
                              
                                    <div className='ml-5' style={{ display: "flex", alignItems: "center" }}>
                                        {/* <i className="fas fa-layer-group" style={{ fontSize: "25px", marginRight: "10px", color: "#035090", backgroundColor: '#E0E0E0', padding: "10px", display: "flex", alignItems: "center", justifyContent: "center", width: '35px', height: '35px', borderRadius: 50 }}></i> */}
                                        <div>
                                            <h6 style={{ fontSize: "12px", color: "gray" }}>Quantity</h6>
                                            <h6>{this.state.vehicleAndDeviceModel.activeQty}</h6>
                                            <h6>{this.state.Qty}</h6>  
                                        </div>
                                        
                                    </div>
                                    <div style={{ display: "flex", padding:15,marginLeft:20, alignItems: "center" }}>
                                        {/* <i className="fas fa-rupee-sign" style={{ fontSize: "20px", marginRight: "10px", color: "#035090", backgroundColor: '#E0E0E0', padding: "10px", display: "flex", alignItems: "center", justifyContent: "center", width: '35px', height: '35px', borderRadius: 50 }}></i> */}
                                        <div>
                                            <h6 style={{ fontSize: "12px", color: "gray" }}>Unit Rate</h6>
                                            <h6>{this.state.vehicleAndDeviceModel.unitPrice}</h6>
                                            <h6>{this.state.UnitPrice}</h6>  
                                            {/* <h6>{new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.state.vehicleAndDeviceModel.grossAmount)}</h6> */}
                                        </div>
                                    </div>
                                    <div style={{ display: "flex", padding:15,marginLeft:20, alignItems: "center" }}>
                                        {/* <i className="fas fa-rupee-sign" style={{ fontSize: "20px", marginRight: "10px", color: "#035090", backgroundColor: '#E0E0E0', padding: "10px", display: "flex", alignItems: "center", justifyContent: "center", width: '35px', height: '35px', borderRadius: 50 }}></i> */}
                                        <div>
                                            <h6 style={{ fontSize: "12px", color: "gray" }}>Gross Amount</h6>
                                            <h6>{new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.state.vehicleAndDeviceModel.grossAmount)}</h6>
                                            <h6>{this.state.GrossAmount}</h6>  
                                        </div>
                                    </div>
                                    <div style={{ display: "flex", padding:15,marginLeft:20,  alignItems: "center" }}>
                                        {/* <i className="fas fa-rupee-sign" style={{ fontSize: "20px", marginRight: "10px", color: "#035090", backgroundColor: '#E0E0E0', padding: "10px", display: "flex", alignItems: "center", justifyContent: "center", width: '35px', height: '35px', borderRadius: 50 }}></i> */}
                                        <div>
                                            <h6 style={{ fontSize: "12px", color: "gray" }}>Tax Amount</h6>
                                            <h6>{this.state.vehicleAndDeviceModel.totalTaxAmount}</h6>
                                            <h6>{this.state.TotalTax}</h6>
                                            {/* <h6>{new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.state.vehicleAndDeviceModel.grossAmount)}</h6> */}
                                        </div>
                                    </div>
                                    <div style={{  padding:15,marginLeft:20, alignItems: "center" }}>
                                        {/* <i className="fas fa-rupee-sign" style={{ fontSize: "20px", marginRight: "10px", color: "#035090", backgroundColor: '#E0E0E0', padding: "10px", display: "flex", alignItems: "center", justifyContent: "center", width: '35px', height: '35px', borderRadius: 50 }}></i> */}
                                            <h6 style={{ fontSize: "12px", color: "gray" }}>Gross Amount</h6>
                                            <h6>{this.state.vehicleAndDeviceModel.totalAmount}</h6>
                                            <h6>{this.state.TotalAmount}</h6>
                                            {/* <h6>{new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.state.vehicleAndDeviceModel.grossAmount)}</h6> */}
                                    </div>
                                </div>
                            {/* </div> */}
                            <div className="modal-body">
                                <div className='card'>
                                    <div className='card-body'>
                                        <DataGrid
                                            dataSource={this.state.vehicleDeviceList}
                                            keyExpr="id"
                                            id='gridHsnCodeMasterList'
                                            columnAutoWidth={true}
                                            showColumnLines={true}
                                            showRowLines={true}
                                            showBorders={true}
                                            rowAlternationEnabled={false}
                                            allowColumnResizing={true}
                                            columnResizingMode='widget'
                                            onRowPrepared={this.handlevehrowPrepared}
                                            width="100%"
                                            onToolbarPreparing={this.onToolbarPreparing}
                                            selectedRowKeys={this.state.selectionRowKeyModel}
                                            onSelectionChanged={this.handleMultipleSelectionChangedModel}
                                            onExporting={this.onExporting} >                                      
                                            <Selection
                                                mode="multiple"
                                                selectAllMode={"allPages"}
                                                showCheckBoxesMode={"always"}
                                            />
                                             <Editing mode="cell"
                                        allowUpdating={true}
                                        allowDeleting={false}
                                        allowAdding={false}
                                        editorOptions={true} />
                                            <Column dataField="vehicleNo" caption="Vehicle#" allowEditing={false} allowSearch={true} allowSorting={true} width={90} />
                                            <Column dataField="serialNo" caption="Serial#" allowSearch={true} allowFiltering={false} allowSorting={true}  allowEditing={false} width={120}/>
                                            <Column dataField="noOfDays" caption="Days /Qty "  allowSearch={true} allowFiltering={false} allowSorting={true} width={90} />
                                            {/* <Column dataField="isBillable" caption="Billable " allowSearch={true} allowFiltering={false} allowSorting={true} /> */}
                                            <Column dataField="isPrintable" caption="Print" allowSearch={true} allowFiltering={false} allowSorting={true} width={50}/>
                                            <Column dataField="unitPrice" caption="Unit Rate" allowSearch={true} allowFiltering={false} allowSorting={true}  width={50}/>
                                       
                                            <Column dataField="billingStartDate"  allowEditing={false}  caption="Start Date" allowSearch={true} allowFiltering={false} allowSorting={true} width={120} dataType="date" format="dd-MMM-yyyy" />                                                                                
                                               <Column dataField="billingEndDate"   allowEditing={false} caption="End Date" allowSearch={true} allowFiltering={false} allowSorting={true} width={120}  dataType="date" format="dd-MMM-yyyy" />                                                                                

                                            <Column dataField="id" caption="Print" allowSearch={true} allowFiltering={false} allowSorting={true} allowEditing={false} visible={false} />
                                            <Column dataField="cnt" caption="Print" allowSearch={true} allowFiltering={false} allowSorting={true} allowEditing={false} visible={false} />
                                                            <SortByGroupSummaryInfo summaryItem="count" />
                                            {/* <GroupPanel visible={false} /> */}
                                            {/* <Template name="toolbarTemplate" /> */}
                                            <HeaderFilter visible={true} />
                                            <SearchPanel visible={true} highlightCaseSensitive={true} width={240} placeholder="Search..." />
                                            {/* <Grouping autoExpandAll={true} /> */}
                                            <Paging defaultPageSize={10} />
                                            {/* <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 50]} showInfo={true} visible={true} /> */}
                                            {/* <Export enabled={true}  allowExportSelectedData={false} fileName="Item current status" /> */}
                                        </DataGrid>

                                    </div>
                                </div>
                                {/* <div className='row mt-2'>
                                <div className='col-6'>
                                    <div className='bg-body-tertiary p-3 rounded'>
                                        <div className='font-weight-bold mb-2'>Vehicle No :-</div>
                                        <span className='text-wrap'>{this.state.billingAddress}</span>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='bg-body-tertiary p-3 rounded'>
                                        <div className='font-weight-bold mb-2'>Devices :-</div>
                                        <span className='text-wrap'>{this.state.shippingAddress}</span>
                                    </div>
                                </div>
                            </div> */}
                            </div>

                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary"
                                    onClick={this.UpdateData}
                                    title="Submit">Submit</button>
                            <button type="submit" className="btn btn-primary"
                                    onClick={this.CalculateInvoice}
                                    title="Re-Calculate">Re-Calculate</button>

                                <button type="button" className="btn btn-primary"
                                    onClick={this.closeModel}
                                    title="Cancel">Cancel</button>
                            </div>
                        </form>
                    </Modal>
                    <LoadPanel
                        shadingColor="rgba(0,0,0,0.4)"
                        position={position}
                        visible={this.state.loadPanelVisible}
                        showIndicator={true}
                        shading={true}
                        showPane={true}
                        hideOnOutsideClick={false}
                    />
                </div>

            </div>
        )
    }

}